interface ProgressRingProps {
  done: number;
  total: number;
  size?: number;
  stroke?: number;
  showLabel?: boolean;
}

export function ProgressRing({
  done,
  total,
  size = 56,
  stroke = 6,
  showLabel = true,
}: ProgressRingProps) {
  const r = (size - stroke) / 2;
  const circumference = 2 * Math.PI * r;
  const ratio = total === 0 ? 0 : Math.min(1, done / total);
  const complete = total > 0 && done >= total;
  return (
    <div
      className="relative shrink-0"
      style={{ width: size, height: size }}
      role="img"
      aria-label={`Opravljeno ${done} od ${total}`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={stroke}
          stroke="var(--surface-2)"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          stroke="var(--done)"
          className="transition-[stroke-dashoffset] duration-700 ease-out"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - ratio)}
          opacity={ratio === 0 ? 0 : 1}
        />
      </svg>
      {showLabel && (
        <span
          className={`absolute inset-0 grid place-items-center font-semibold tabular-nums ${
            complete ? 'text-done-ink' : 'text-text'
          }`}
          style={{ fontSize: Math.max(11, size * 0.25) }}
        >
          {done}/{total}
        </span>
      )}
    </div>
  );
}
